import React from 'react';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import SEO from '../../components/SEO';
import NavbarHome from '../../components/NavbarHome/NavbarHome';
import Footer from '../../components/Footer/Footer';
import { handleRipple } from '../../helpers/ripple';

import {
  StyledSection,
  StyledContentBlock,
  ContentWrapper,
  ErrorBlock,
  AnimatedErrorBlock,
  AnimatedSVG,
  DescriptionWrapper,
  ErrorDescription,
  ErrorActions,
  RightArrow,
  ScanBlock,
  ScanTitle,
  ScanText,
  ScanImage,
  ScanLink,
} from './styled';

const ErrorPage = () => {
  const { locale, messages } = useIntl();

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  return (
    <>
      <SEO page="404" />
      <Helmet>
        <script
          src={
            process.env.MPC_WIDGET_URL ||
            'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
          }
          type="text/javascript"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
          as="font"
          type="font/ttf"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
          rel="stylesheet"
          key="google-fonts2"
        />

        <style>
          {`
            @font-face {
              font-family: 'Elza Condensed';
              src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Satoshi Variable Medium';
              src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
            @font-face {
              font-family: 'Chivo Mono';
              src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
              font-weight: normal;
              font-style: normal;
              font-display: swap;
            }
          `}
        </style>
      </Helmet>
      <NavbarHome locale={locale} />
      <StyledSection>
        <StyledContentBlock>
          <ContentWrapper>
            <ErrorBlock>
              <AnimatedErrorBlock>
                {messages['404.content.animationImage'] ? (
                  <AnimatedSVG
                    src={messages['404.content.animationImage']}
                    alt="404 Block Not Found Animation"
                  />
                ) : (
                  messages['404.content.image'] && (
                    <AnimatedSVG
                      src={messages['404.content.image']}
                      alt={messages['404.content.imageAlt']}
                    />
                  )
                )}
              </AnimatedErrorBlock>
              <DescriptionWrapper>
                <ErrorDescription>
                  {messages['404.content.subText']}
                </ErrorDescription>
              </DescriptionWrapper>

              <ErrorActions
                onClick={() => handleBackToHome()}
                onMouseEnter={handleRipple}
              >
                {messages['404.content.buttonText']}
                <RightArrow className="right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <path
                      d="M13.019 7.4389L7.62158 12.8373L6.74463 11.9604L10.646 8.05902H1.85986V6.81976H10.647L6.74463 2.9184L7.62158 2.04144L13.019 7.4389Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </RightArrow>
              </ErrorActions>
            </ErrorBlock>
            <ScanBlock>
              <ScanTitle>{messages['404.content.scanTitle']}</ScanTitle>
              <ScanText>{messages['404.content.scanText']}</ScanText>
              <ScanImage
                src={messages['404.content.scanImage']}
                alt="scanner"
              />
              <ScanLink href="/">
                {messages['404.content.scanLinkText']}
              </ScanLink>
            </ScanBlock>
          </ContentWrapper>
        </StyledContentBlock>
      </StyledSection>
      <Footer />
    </>
  );
};

export default ErrorPage;
